import React from 'react'
import { useGameSettings } from '../components/slotGame/slotData'

const Unauthorized = () => {
    const { gameBackgroundUrl } = useGameSettings()
    return (
        <div
            className='flex flex-col h-screen w-screen overflow-hidden flex-1 bg-[#12151D] bg-contain'
            style={{
                backgroundImage: `url(${gameBackgroundUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}
        >
            <div className="bg-gray-900 text-white font-semibold w-full h-full bg-opacity-80 flex flex-col items-center justify-center gap-4 z-50 backdrop-blur-sm" style={{ pointerEvents: 'all' }}>
                {/* Un-Authorized access. */}
                <div
                    className='bg-center bg-no-repeat w-[50%] h-[60%] bg-contain'
                    style={{
                        backgroundImage: `url("/404-page.png")`,
                        backgroundSize:"100% 100%"
                    }}
                ></div>
            </div>
        </div>
    )
}

export default Unauthorized